import AddPaymentMethodModal from './AddPaymentMethodModal';

export default AddPaymentMethodModal;
